import React from 'react';
import MuiDialogContentText from '@mui/material/DialogContentText';

const DialogContentText = (props) => <MuiDialogContentText {...props} />;
export default DialogContentText;
